import React from 'react'
import MaterialSymbol from '../material-symbol'

const LeftPanelOpen = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="left_panel_open" {...props} />
))

LeftPanelOpen.displayName = 'LeftPanelOpen'

export default LeftPanelOpen
